export type MinSideAllowedTradeType =
    | 'BUY'
    | 'SELL'
    | 'SSW'
    | 'BSW'
    | 'PERIODIC'
    | 'TO'
    | 'TI'
    | 'TOTI'
    | 'CUSTOMDIVI'
    | 'CUSTOM_EPD'
    | 'CUSTOM_EPW';

export interface FundUtvikling {
    iAar: number;
    sisteAar: number | null;
    siste3Aar: number | null;
    siste5Aar: number | null;
    prosentSiste5Aar: number;
    prosentSiste3Aar: number;
    prosentSiste10Aar: number;
}

export interface FundClassRef {
    isin: string;
    name: string;
    shareClassThreshold: number;
}

export interface Fund {
    navn: string;
    id: string;
    utvikling: FundUtvikling;
    isin: string;
    fundClass: string;
    risiko: number;
    rating: number;
    aksjesparekontoKompatibel: boolean;
    minimumsBelopEngangsKjop: number;
    minimumsBelopPeriodiskKjop: number;
    minimumOrderAmountFirstTimePurchase: number;
    managementFee: number;
    ongoingCharge: number;
    maxFrontEndLoad: number;
    maximumExitFee: number;
    sustainabilityScore: number;
    eikespirer: number;
    produktarkUrl: string;
    allowedTradeTypes: MinSideAllowedTradeType[];
    currency: string;
    platformFee: number;
    kickback: number;
    kickbackAdjustedOngoingCharge: number;
    yearlyCost: number;
    externalFund: boolean;
    sellInQuantityAmount: string;
    sellSwitchInQuantityAmount: string;
    shareClassThreshold: null | number;
    mutualFundClassReference: FundClassRef;
    previousMutualShareClassReference: FundClassRef;
    nextMutualShareClassReference: FundClassRef;
    morningstarUrl: string;
    produktarUrl: string;
    descriptionList?: string[]
}

export enum GraphDataPeriod {
    SINCE_START = 'SINCE_START',
    THIS_YEAR = 'THIS_YEAR',
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_3_MONTHS = 'LAST_3_MONTHS',
    LAST_6_MONTHS = 'LAST_6_MONTHS',
    LAST_1_YEAR = 'LAST_1_YEAR',
    LAST_3_YEARS = 'LAST_3_YEARS',
    LAST_5_YEARS = 'LAST_5_YEARS',
}

export enum GraphDataResolution {
    DAILY = 'DAILY',
    MONTHLY = 'MONTHLY',
    ANNUAL = 'ANNUAL',
}

export type GraphDataApi = {
    SecurityId: string;
    securityId: string;
    timePeriod: number;
    frequency: GraphDataResolution;
    utviklingsverdier: {
        dato: string;
        verdi: number;
    }[];
}[];

export type GraphData = {
    series: {
        points: {
            x: number;
            y: number;
        }[]
    }[];
};
